import styled, { AnyStyledComponent } from 'styled-components';
import Skeleton from '../Skeleton/skeleton';

const heightByRatio = ({ width , ratio }: {width: string | number, ratio: number }) => `calc(${ratio/100} * ${width})`;

export const HeadshotSkeleton: AnyStyledComponent = styled(Skeleton)`
    height: ${heightByRatio};
`;

